export default __webpack_public_path__ + "static/trends-dark-4cbb0504dd86ba001eaad8bced49fc93.png";